<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="product-weight1">
                    <icon name="boxes"></icon>
                    น้ำหนักโฟม
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-weight2">
                    <icon name="download"></icon>
                    น้ำหนักแก้ว,ฝา,แก้วชุด,PP
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-weight3">
                    <icon name="upload"></icon>
                    น้ำหนักหลอด
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-weight4">
                    <icon name="upload"></icon>
                    น้ำหนักช้อน
                </b-nav-item>
                &nbsp
                <b-nav-item router-link to="product-weight5">
                    <icon name="upload"></icon>
                    น้ำหนักเข่ง
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view/>
        </div>
    </div>
</template>

<script>
import {
    canInventoryMaterialsImport,
    canInventoryMaterialsExport
} from "../../util/Permissions"

export default {
    name: "product-weight-layout",
    computed: {
        canInventoryMaterialsImport,
        canInventoryMaterialsExport
    },
};
</script>

<style scoped></style>
